import { FC } from 'react'
import styled from 'styled-components'
import { AppHeader } from 'widgets/AppHeader'

export const withHeaderHOC =
  (Component: FC<any>, pageName = ''): FC<any> =>
  ({ children, ...props }) =>
    (
      <>
        <AppHeader pageName={pageName} />
        <ComponentLayout onClick={() => window?.scrollTo(0, 0)}>
          <ComponentContainer>
            <Component {...props} />
          </ComponentContainer>
          {children}
        </ComponentLayout>
      </>
    )

const ComponentLayout = styled.div`
  display: grid;
  grid-template-columns: 950px auto;
  height: calc(100vh - 82px);
  overflow-x: hidden;
  overflow-y: hidden;
  @media (max-width: 1360px) {
    grid-template-columns: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
`

const ComponentContainer = styled.div`
  padding-top: 0;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  height: max-content;
  max-width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  @media (min-width: 1361px) {
    max-height: calc(100vh - 102px);
  }
`
